import { useBoToast } from '@invivodf/common/src/application/composables'
import { useSeller } from '@invivodf/common/src/application/composables/useSeller'
import { ImportReportFetcher } from '@invivodf/common/src/contexts/parameters'
import { retrieveAssociationImportReport, retrieveAssociationImportReports } from '../../../dependency-injection'

export const useDiscountAssociationImportReport = (): ImportReportFetcher => {
  const seller = useSeller()

  const { showNotificationError } = useBoToast()

  const fetchAll = async () => {
    try {
      return await retrieveAssociationImportReports.execute(seller.value.id)
    } catch (err) {
      showNotificationError(err.message)
      return []
    }
  }

  const fetchOne = async (importId: number) => {
    try {
      return await retrieveAssociationImportReport.execute(seller.value.id, importId)
    } catch (err) {
      showNotificationError(err.message)
      throw err
    }
  }

  return { fetchOne, fetchAll, type: 'discount-association' }
}
